module.exports = __webpack_public_path__ + "static/media/John_the_ripper-logo.b6659973.png";